import { createFileRoute } from '@tanstack/react-router';
import { CompanyScreen } from '@/features/organisation/components/company-screen';

// Onglet « Entreprise » des réglages (FR-01) : fiche entreprise (nom, SIRET,
// logo). Le chrome vient du layout _app/settings.
export const Route = createFileRoute('/_app/settings/organisation')({
  component: CompanyScreen,
});
